import api from './api';

export const quizService = {
  // Get all quizzes with optional book filtering
  async getQuizzes(params = {}) {
    const response = await api.get('/quizzes/', { params });
    return response.data;
  },

  async getQuizCount(params = {}) {
    const response = await api.get('/quizzes/count', { params });
    return response.data;
  },

  // Get the featured quiz of the day (response includes quiz + book_title)
  async getFeaturedQuiz() {
    const response = await api.get('/quizzes/featured');
    return response.data;
  },

  // Get quizzes for a specific book
  async getQuizzesByBook(bookId) {
    const response = await api.get(`/quizzes/book/${bookId}`);
    return response.data;
  },

  // Get a specific quiz by ID
  async getQuiz(quizId) {
    const response = await api.get(`/quizzes/${quizId}`);
    return response.data;
  },

  // Get questions for a specific quiz
  async getQuizQuestions(quizId) {
    const response = await api.get(`/questions/quiz/${quizId}`);
    return response.data;
  },

  // Submit quiz answers
  async submitQuiz(quizId, submissionData) {
    const response = await api.post(`/questions/quiz/${quizId}/submit`, submissionData);
    return response.data;
  },

  // Create an anonymous friend challenge
  async createChallenge(quizId, result) {
    const response = await api.post(`/quizzes/${quizId}/challenges`, result);
    return response.data;
  },

  async getChallenge(challengeId) {
    const response = await api.get(`/quizzes/challenges/${challengeId}`);
    return response.data;
  },

  // Create a new quiz (admin only)
  async createQuiz(quizData) {
    const response = await api.post('/quizzes/', quizData);
    return response.data;
  },

  // Update a quiz (admin only)
  async updateQuiz(quizId, quizData) {
    const response = await api.put(`/quizzes/${quizId}`, quizData);
    return response.data;
  },

  // Delete a quiz (admin only)
  async deleteQuiz(quizId) {
    const response = await api.delete(`/quizzes/${quizId}`);
    return response.data;
  }
};